let MakeAppointmentServicesInfo = {
  // Services
  SESSION_NAME: 'appointment_services',
  singleTirePrice: null,
  discountRuleId: null,
  promoDiscount: null,
  dollarAmount: null,
  percentAmount: null,
  minAmount: null,
  quantity: null,

  // Info
  savingAppointment: false,
  storeData: null,
  dateTime: null,

  /* Initialize */
  init: function (json) {
    // form_page_load — tracks entry into the appointment flow on the services info step
    window.mjtPush && window.mjtPush('form_page_load', {
      form_type: 'appointment'
    });
    
    // Services
    MakeAppointmentServicesInfo.bindEvents();
    MakeAppointmentServicesInfo.initServiceSession();

    //store unchanging values for use later
    MakeAppointmentServicesInfo.singleTirePrice = jQuery('#appt-tire-make-model').first().data('singleTirePrice');
    let tireRebateEle = jQuery('#appt-tire-rebate').first();

    MakeAppointmentServicesInfo.discountRuleId = tireRebateEle.data('discountRuleId');
    MakeAppointmentServicesInfo.dollarAmount = tireRebateEle.data('dollarAmount');
    MakeAppointmentServicesInfo.percentAmount = tireRebateEle.data('percentAmount');
    MakeAppointmentServicesInfo.minAmount = tireRebateEle.data('minAmount');

    MakeAppointmentServicesInfo.initCheckboxValidation();

    //populate the MakeAppointmentServicesInfo variables, to make sure the email quote has the info it needs
    jQuery('#tire-qty-select').trigger('change');

    // Info
    MakeAppointmentServicesInfo.vehicleSearchEvents();
    MakeAppointmentServicesInfo.formOnSubmit();
    MakeAppointmentServicesInfo.storeData = json;

    //Disable the "Select" invalid tooltip and scroll to the top of the appointment form
    document.querySelector("form").addEventListener("invalid", function (event) {
      event.preventDefault();
      jQuery('html, body').scrollTop(jQuery('#make-appointment-services-info-form').offset().top);

      //hide loading icon
      hideLoadingIcon();
    }, true);

    MakeAppointmentServicesInfo.vehicleInfo = JSON.parse(Util.getCookie('vehicle_info')) || {};
    let [initSelectName] = Object.keys(MakeAppointmentServicesInfo.vehicleInfo);
    if (initSelectName) jQuery(`[name=${initSelectName}]`).val(MakeAppointmentServicesInfo.vehicleInfo[initSelectName]).change();

    // form_start — fires once on first interaction with any form field
    jQuery('#make-appointment-services-info-form input, #make-appointment-services-info-form select, #make-appointment-services-info-form textarea').on('focus change', function () {
      if (sessionStorage.getItem('mjt_form_started') !== 'true') {
        sessionStorage.setItem('mjt_form_started', 'true');
        window.mjtPush && window.mjtPush('form_start', { form_type: 'appointment' });
      }
    });
  },

  bindEvents: function () {
    MakeAppointmentServicesInfo.handleShowMoreEvent();
    MakeAppointmentServicesInfo.handleQtyChangeEvent();
    MakeAppointmentServicesInfo.handleRemoveTireEvent();
    MakeAppointmentServicesInfo.groupAddOnsEvent();
    MakeAppointmentServicesInfo.handleVAStateInspectionEvent();
    MakeAppointmentServicesInfo.oilChangeModal.bindEvents();

    //add on click event handler for the add on checkboxes
    jQuery('#appt-tire-service-wrapper input').on('change', function () {
      MakeAppointmentServicesInfo.calculateTotals();
    });

    jQuery('.make-appointment-services input[id*=\'NewTires\'][type=checkbox]').on('change', function () {
      // Toggle required tire sections
      if (jQuery(this).is(":checked")) {
        jQuery('.make-appointment-info').addClass('with-tire-service');
        jQuery('.make-appointment-vehicle-info select[class*=\'form-control\']').addClass('required');
        jQuery('.make-appointment-vehicle-info select[class*=\'form-control\']').attr('required', true);
      }
      else {
        jQuery('.make-appointment-info').removeClass('with-tire-service');
        jQuery('.make-appointment-vehicle-info select[class*=\'form-control\']').removeClass('required');
        jQuery('.make-appointment-vehicle-info select[class*=\'form-control\']').removeAttr('required');
      }
    });
  },

  handleShowMoreEvent: function () {
    jQuery('.show-more-services-btn').on('click', function () {
      //hide or display services and change button text and icon
      if (jQuery(this).data('state') === 'more') {
        //change button text, icon, and state
        jQuery(this).html('SHOW LESS<i class="fa fa-caret-up"></i>');
        jQuery(this).data('state', 'less');
        //show all services
        jQuery(this).prev('.service-list').find('li').show(100);
      } else {
        //change button text, icon, and state
        jQuery(this).html('SHOW MORE<i class="fa fa-caret-down"></i>');
        jQuery(this).data('state', 'more');
        //hide services after 4th
        jQuery(this).prev('.service-list').find('li:nth-of-type(1n + 5)').hide(100);
      }
    });
  },

  handleQtyChangeEvent: function () {
    //quantity select change event
    jQuery('#tire-qty-select').on('change', function () {
      //new subtotal = selected quantity * price of a single tire
      MakeAppointmentServicesInfo.quantity = parseInt(jQuery(this).val());

      let tireTotal = MakeAppointmentServicesInfo.quantity * MakeAppointmentServicesInfo.singleTirePrice;
      tireTotal = tireTotal.toFixed(2);
      jQuery('#appt-tire-only-price').text(tireTotal);

      //update tire promo (if exists)
      if (MakeAppointmentServicesInfo.discountRuleId) {
        MakeAppointmentServicesInfo.promoDiscount = Util.getPromoDiscount(
          MakeAppointmentServicesInfo.discountRuleId,
          MakeAppointmentServicesInfo.quantity,
          MakeAppointmentServicesInfo.singleTirePrice,
          MakeAppointmentServicesInfo.percentAmount,
          MakeAppointmentServicesInfo.dollarAmount,
          MakeAppointmentServicesInfo.minAmount
        );

        //update and show the discount wrapper as needed
        if (MakeAppointmentServicesInfo.promoDiscount) {
          // update total discount price for Instant and Mail-in Rebate with Drive Card with 4 tires offer rule
          if (MakeAppointmentServicesInfo.discountRuleId === 23) {
            MakeAppointmentServicesInfo.promoDiscount = MakeAppointmentServicesInfo.promoDiscount * 3;
            // Format promo discount number to use 2 decimal places to handle whole number discount values
            MakeAppointmentServicesInfo.promoDiscount = MakeAppointmentServicesInfo.promoDiscount.toFixed(2);
          }
          // update total discount price for Promotion per Tire
          else if (MakeAppointmentServicesInfo.discountRuleId === 24) {
            MakeAppointmentServicesInfo.promoDiscount = MakeAppointmentServicesInfo.promoDiscount * MakeAppointmentServicesInfo.quantity;
            MakeAppointmentServicesInfo.promoDiscount = MakeAppointmentServicesInfo.promoDiscount.toFixed(2);
          }
          jQuery('#appt-tire-rebate').text(MakeAppointmentServicesInfo.promoDiscount);
          jQuery('#appt-tire-rebate-wrapper').show();
        } else {
          jQuery('#appt-tire-rebate-wrapper').hide();
        }
      }

      //update the calculated add-on pricing
      jQuery('#appt-tire-service-wrapper input').each(function () {
        let input = jQuery(this).first();
        let multiplier = input.data('perTire') === 1 ? MakeAppointmentServicesInfo.quantity : 1;
        let price = input.data('addOnPrice');
        let newTotal = multiplier * price;

        //update the div's text to display the correct price
        jQuery('div[data-add-on-id=' + input.prop('id') + ']').text(newTotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
      });

      MakeAppointmentServicesInfo.calculateTotals();
    });
  },

  handleRemoveTireEvent: function () {
    //remove tire click event
    jQuery('#remove-wrapper').on('click', function () {
      //expiriing the cookies will remove them
      Util.setCookie('apptTireSku', '');
      Util.setCookie('apptTireQty', '');
      Util.setCookie('apptTirePromo', '');
      Util.setCookie('apptAddOns', '');

      //and then reload the page to refresh what is displayed
      window.location.reload();
    });
  },
  initServiceSession: function () {
    if (sessionStorage.getItem(MakeAppointmentServicesInfo.SESSION_NAME)) {
      let info = JSON.parse(sessionStorage.getItem(MakeAppointmentServicesInfo.SESSION_NAME));

      jQuery.each(info, function (i, key) {
        jQuery('#' + key.id).attr('checked', 'true');
      });
    }
    if (jQuery('.make-appointment-services input[id*=\'NewTires\'][type=checkbox]').is(":checked")) {
      jQuery('.make-appointment-info').addClass('with-tire-service');
    }
    else {
      jQuery('.make-appointment-vehicle-info select[class*=\'form-control\']').removeClass('required');
      jQuery('.make-appointment-vehicle-info select[class*=\'form-control\']').removeAttr('required');
    }
  },
  resetSession: function () {
    if (sessionStorage.getItem(MakeAppointmentServicesInfo.SESSION_NAME)) {
      sessionStorage.removeItem(MakeAppointmentServicesInfo.SESSION_NAME);
    }
  },
  calculateTotals: function () {
    let newSubtotal = MakeAppointmentServicesInfo.quantity * MakeAppointmentServicesInfo.singleTirePrice;

    //format function from https://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-dollars-currency-string-in-javascript 
    jQuery('#appt-tire-subtotal').text(newSubtotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));

    //total all selected add-ons
    MakeAppointmentServicesInfo.feeTotal = 0;

    jQuery('#appt-tire-service-wrapper input:checked').each(function () {
      let multiplier = jQuery(this).data('perTire') === 1 ? MakeAppointmentServicesInfo.quantity : 1; //account for per tire pricing
      MakeAppointmentServicesInfo.feeTotal += multiplier * jQuery(this).data('addOnPrice');
    });

    //update displayed total
    let newTotal = MakeAppointmentServicesInfo.promoDiscount ? newSubtotal + MakeAppointmentServicesInfo.feeTotal - MakeAppointmentServicesInfo.promoDiscount : newSubtotal + MakeAppointmentServicesInfo.feeTotal;
    let totalText = 'estimated total price';
    MakeAppointmentServicesInfo.promoDiscount ? totalText += ' after rebate' : '';

    jQuery('#appt-tire-total-wrapper span').text(totalText);
    jQuery('#appt-tire-total-price').text(newTotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
  },
  groupAddOnsEvent: function () {
    jQuery('.appt-add-on input').on('change', function () {
      let addOnId = jQuery(this).prop('id');
      let groupId = jQuery(this).data('groupId');

      //account for addons that don't have a group
      if (!groupId) {
        return;
      }

      let groupMembers = jQuery('input[data-group-id="' + groupId + '"]').toArray();

      //toggle the checked state of the first group member found that is not the source of the event
      groupMembers.forEach((member) => {
        let checkbox = jQuery(member);
        if (checkbox.prop('id') !== addOnId) {
          checkbox.prop('checked', !checkbox.prop('checked'));
        }
        return;
      });
    });
  },
  // Handles popover event when State Inspection service is selected for VA stores
  handleVAStateInspectionEvent: function () {
    jQuery("[data-toggle=popover]").popover({
      placement: "top",
      content: "A Store Teammate will call you after submitting the Appointment Request to confirm availability",
      trigger: "click"
    });
  },

  /**
   * Create jQuery hook that submits form when submit button is clicked.
   * jQuery hook does not move to next page if no services are checked
   * jQuery hook does not move to next page if email is not valid
   */
  formOnSubmit: function () {
    jQuery('#make-appointment-services-info-form').submit(function (e) {
      showLoadingIcon();
      e.preventDefault();

      // cancel form submit if there is no services selected.
      if (jQuery('.make-appointment-services input[type=checkbox]:checked').length === 0) {
        hideLoadingIcon();
        return;
      }

      // validate email against API. If not valid, do not execute form submit
      const emailAddress = jQuery('#apptEmailInput').val().trim();
      MakeAppointmentServicesInfo.validateEmail(emailAddress)
        .then(() => {
          // Only check for oil change after email is confirmed valid
          const oilChangeChecked = jQuery('.make-appointment-services input[type=checkbox]').filter(function () {
            return this.id.indexOf('Oil_Change') !== -1 || jQuery(this).val() === 'Oil Change';
          }).is(':checked');

          if (!oilChangeChecked && !MakeAppointmentServicesInfo.oilChangeModal.userDeclinedOilChange) {
            hideLoadingIcon();
            MakeAppointmentServicesInfo.oilChangeModal.show();
            return;
          }

          const selectedServices = MakeAppointmentServicesInfo.getSelectedServices();
          sessionStorage.setItem(MakeAppointmentServicesInfo.SESSION_NAME, JSON.stringify(selectedServices));

          const tireSummary = MakeAppointmentServicesInfo.getSelectedTireSummary();
          sessionStorage.setItem('appointment_tire', JSON.stringify(tireSummary || ""));

          const contactSummary = MakeAppointmentServicesInfo.getContactSummary();
          sessionStorage.setItem('appointment_contact', JSON.stringify(contactSummary));

          const vehicleSummary = MakeAppointmentServicesInfo.getVehicleSummary();
          sessionStorage.setItem('appointment_vehicle', JSON.stringify(vehicleSummary));

          if (MakeAppointmentCurrentPage.appointmentFlow) { // this is sometimes null bc of a bigger bug somewhere
            MakeAppointmentCurrentPage.appointmentFlow.servicesInfo = true;
          }
          MakeAppointmentCurrentPage.updateAppointmentFlowSession();

          // form_steps step 1 — services info complete, proceeding to date/time
          window.mjtPush && window.mjtPush('form_steps', {
            form_step: 1,
            step_name: 'services_info',
            form_type: 'appointment'
          });
          sessionStorage.setItem('mjt_action_taken', 'true');

          window.location = `${window.location.origin}/appointment/date-time`;
        })
        .catch(() => {
          MakeAppointmentServicesInfo.errorMessageToggle(true, '#invalid-email-error');
          hideLoadingIcon();
        })
    })
  },


  /**
   * Validates inputted email address against API
   * @param {string} emailAddress email address to be validated
   */
  validateEmail: function (emailAddress) {
    const dataObj = {
      'email': emailAddress
    }
    return new Promise((resolve, reject) => {
      // change this function to return true or false, depending on api resonse.
      // IF API DOES NOT RESPOND, resolve
      jQuery.ajax({
        url: `${Util.emailApiHost}validate/`,
        beforeSend: function (request) {
          request.setRequestHeader('x-api-key', Util.emailApiKey);
        },
        dataType: 'json',
        type: "POST",
        data: JSON.stringify(dataObj),
        contentType: "application/json;charset=utf-8",
        success: function (response) {
          // verify that is_valid parameter exists and it is false.
          // want to allow customers to make an appointment if there is 
          // issue with api
          if(Object.hasOwn(response, 'is_valid') && !response.is_valid) {
            reject();
          } else {
            resolve();
          }
        },
        error: function (response) {
          console.log(response);
          reject();
        }
      })
    })
  },

  /**
   * Get all selected services from form and return them all as a list
   * @returns {Array} list of service objects, {name: <NAME>, id: <ID>}
   */
  getSelectedServices: function () {
    const servicesInfo = new Array();
    jQuery('.make-appointment-services input[type=checkbox]:checked').each(function (i, checkedService) {
      servicesInfo.push({
        name: checkedService.value,
        id: checkedService.id
      });
    });
    return servicesInfo;
  },

  /**
   * Function to calculate fees and rebate for selected tire, then use jQuery to 
   * retrieve necessary tire data from HTML. returns false if no tire is selected
   * @returns Tire Summary Object OR false
   */
  getSelectedTireSummary: function () {
    // return false if there is no tire data
    if (!jQuery('#make-appointment-services-info-form').data('hasTire')) {
      return false;
    }

    const fees = [];
    const checkedServices = jQuery('#appt-tire-service-wrapper input:checked');
    checkedServices.each(function () {
      const inputCheckboxElement = jQuery(this);
      const isPerTire = inputCheckboxElement.data('perTire');
      const addOnPrice = inputCheckboxElement.data('addOnPrice');
      const perTireMultiplier = isPerTire ? MakeAppointmentServicesInfo.quantity : 1;
      const feeTotal = perTireMultiplier * addOnPrice;

      const childFees = [];

      if (inputCheckboxElement.data('hasChildren')) {
        const jQueryElementName = `#${inputCheckboxElement.prop('id')}childList`;
        jQuery(jQueryElementName).children('li').each(function () {
          childFees.push(jQuery(this).text());
        });
      };

      fees.push({
        //format function from https://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-dollars-currency-string-in-javascript 
        feeTotal: feeTotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
        price: '' + inputCheckboxElement.data('addOnPrice'),
        name: inputCheckboxElement.next('label').text(),
        children: childFees,
        perTire: inputCheckboxElement.data('perTire')
      });
    });

    const rebate = jQuery('#appt-tire-rebate').is(':visible') ? jQuery('#appt-tire-rebate').text() : '';

    const tireSummary = {
      makeModel: jQuery('#appt-tire-make-model').text(),
      size: jQuery('#appt-tire-size').text(),
      sku: jQuery('#appt-tire-sku').text(),
      type: jQuery('#appt-tire-type').text(),
      image: jQuery('#appt-tire-info-wrapper img').data('tireImage'),
      qty: MakeAppointmentServicesInfo.quantity,
      tireOnlyPrice: jQuery('#appt-tire-only-price').text(),
      subtotal: jQuery('#appt-tire-subtotal').text(),
      total: jQuery('#appt-tire-total-price').text(),
      tireRebate: rebate,
      fees: fees,
      tireRebateDescription: jQuery('#appt-tire-rebate-label').text(),
    };

    return tireSummary;
  },

  /**
   * Gather contact information and campaign details from page and return an
   * object with the data
   * @returns contactSummary object
   */
  getContactSummary: function () {
    const queryParams = new URLSearchParams(location.search);
    const isGoogleUtmSource = queryParams.get('utm_source') == "google";
    const isPaidMedium = queryParams.get('utm_medium') == "paid";
    const isVperksCampaign = queryParams.get('utm_campaign') == "vperks";
    const isVperksGoogleAdsCampaign = isGoogleUtmSource && isPaidMedium && isVperksCampaign;

    const contactSummary = {
      firstName: jQuery('#apptFirstNameInput').val().trim(),
      lastName: jQuery('#apptLastNameInput').val().trim(),
      email: jQuery('#apptEmailInput').val().trim(),
      phone: jQuery('#apptMobilePhoneInput').val().trim(),
      altPhone: '',
      optInPromotion: jQuery('#apptOptInInput').prop('checked'),
      isVperksCampaign: Util.getCookie("vperks_google_ads_campaign") || isVperksGoogleAdsCampaign,
      appointmentSource: Util.getCookie("appointment_source") || '',
      comments: jQuery('#apptCommentsInput').val().trim(),
    };
    return contactSummary;
  },

  /**
   * get selected vehicle data from form. Will return object with null values if no vehicle is required
   * @returns vehicleSummary object. Object will contain all null values if a vehicle is not required
   */
  getVehicleSummary: function () {
    let vehicleSummary = null;
    if (jQuery('.make-appointment-vehicle-info select[class*=\'form-control\']').attr('required')) {
      vehicleSummary = {
        year: jQuery('#vehicle-year').val().trim(),
        make: jQuery('#vehicle-make').val().trim(),
        model: jQuery('#vehicle-model').val().trim(),
        option: jQuery('#vehicle-option').val().trim()
      }
    }
    else {
      vehicleSummary = {
        year: null,
        make: null,
        model: null,
        option: null
      }
    }
    return vehicleSummary
  },


  formCheck: function () {
    const selectedOptions = jQuery("select.form-control.required option:selected");
    const inputFields = jQuery("input.form-control.required");
    const serviceCheckboxes = jQuery('.make-appointment-services input[type=checkbox]:checked');

    let contactInformationError = false;
    let serviceError = false;
    let missingFields = []

    jQuery.each(selectedOptions, function (i, option) {
      if (option.value === '' || option.value === null) {
        contactInformationError = true;
        missingFields.push(option.getAttribute("error-key"));
      }
    });

    jQuery.each(inputFields, function (i, input) {
      if (input.value === '' || input.value === null || input.validity.valid === false) {
        contactInformationError = true;
        missingFields.push(input.getAttribute("error-key"));
      }
    });

    if (serviceCheckboxes.length === 0) {
      serviceError = true;
    }

    this.errorMessageToggle(contactInformationError, '#contact-form-error', missingFields);
    this.errorMessageToggle(serviceError, '#service-form-error');
  },

  errorMessageToggle: function (error, formId, missingFields = []) {
    var errorContainer = jQuery(formId);
    if (error) {
      //remove previous error lists to prevent duplicates
      jQuery(errorContainer).children("ul").remove();
      // put all the missing fields in a html list, then append it to error container
      if (missingFields.length > 0) {
        let htmlErrorListString = "<ul class='missing-params-'>"
        missingFields.forEach(missingField => {
          htmlErrorListString += `<li>${missingField}</li>`
        })
        htmlErrorListString += "<ul>"
        jQuery(errorContainer).append(htmlErrorListString)
      }
      jQuery(errorContainer).css('display', 'block');
      var offset = jQuery(errorContainer).offset();
      offset.left -= 300;
      offset.top -= 300;

      jQuery('html, body').animate({
        scrollTop: offset.top,
        scrollLeft: offset.left
      });
    } else {
      // hide error
      jQuery(errorContainer).css('display', 'none');
    }
  },

  //hook up events for searching by vehicle
  vehicleSearchEvents: function () {
    jQuery('#vehicle-year').on('change', function () {
      //clear all lower levels when changing this level
      let makeSelect = jQuery('#vehicle-make');
      MakeAppointmentServicesInfo.resetSelect(makeSelect);
      MakeAppointmentServicesInfo.resetSelect(jQuery('#vehicle-model'));
      MakeAppointmentServicesInfo.resetSelect(jQuery('#vehicle-option'));

      let queryParams = {
        'year': this.value
      };

      let selectName = jQuery(this).attr('name');
      let shouldAutoFill = MakeAppointmentServicesInfo.vehicleInfo[selectName] == this.value

      MakeAppointmentServicesInfo.updateSelect('vehicle/makes', queryParams, makeSelect, null, shouldAutoFill);
    });

    jQuery('#vehicle-make').on('change', function () {
      //clear all lower levels when changing this level
      let modelSelect = jQuery('#vehicle-model');
      MakeAppointmentServicesInfo.resetSelect(modelSelect);
      MakeAppointmentServicesInfo.resetSelect(jQuery('#vehicle-option'));

      let queryParams = {
        'year': jQuery('#vehicle-year').val(),
        'make': this.value
      };

      let selectName = jQuery(this).attr('name');
      let shouldAutoFill = MakeAppointmentServicesInfo.vehicleInfo[selectName] == this.value

      MakeAppointmentServicesInfo.updateSelect('vehicle/models', queryParams, modelSelect, null, shouldAutoFill);
    });

    jQuery('#vehicle-model').on('change', function () {
      //clear all lower levels when changing this level
      let optionSelect = jQuery('#vehicle-option');
      MakeAppointmentServicesInfo.resetSelect(optionSelect);

      let queryParams = {
        'year': jQuery('#vehicle-year').val(),
        'make': jQuery('#vehicle-make').val(),
        'model': this.value.replace('"', '\\"')
      };

      let selectName = jQuery(this).attr('name');
      let shouldAutoFill = MakeAppointmentServicesInfo.vehicleInfo[selectName] == this.value

      MakeAppointmentServicesInfo.updateSelect('vehicle/options', queryParams, optionSelect, 'Option', shouldAutoFill);
    });
  },

  resetSelect: function (select) {
    select.attr('disabled', true);
    select.find('option').not(':first').remove(); //leave the first option with the name of the select
    select.children()[0].selected = true;
  },

  //retreive data from the endpoint to populate targetSelect with
  //queryParams are used to get the correct data from the endpoint, dataProperty is the value coming back in the response object
  updateSelect: function (endpoint, queryParams, targetSelect, dataProperty, shouldAutoFill) {
    //lock all enabled selects so the user can't change them while the ajax request is pending
    //lock the find button as well to prevent submitting an incomplete form
    let unlocked = jQuery('#tab-tire-search-wrapper').find('select:enabled, button');
    unlocked.attr('disabled', true);

    let req = jQuery.ajax({
      url: Util.lambdaHost + endpoint,
      beforeSend: function (request) {
        request.setRequestHeader('x-api-key', Util.lambdaApiKey);
      },
      type: 'GET',
      data: queryParams,
      success: function (response) {
        if (dataProperty) {
          jQuery.each(response, function (index, item) {
            targetSelect.append(new Option(item[dataProperty], item[dataProperty]));
          });
        } else {
          jQuery.each(response, function (index, item) {
            targetSelect.append(new Option(item, item));
          });
        }

        targetSelect.removeAttr('disabled');
        let targetName = targetSelect.attr('name');

        if (shouldAutoFill && MakeAppointmentServicesInfo.vehicleInfo[targetName]) {
          //fill form using previous search vehicle info
          jQuery(targetSelect).val(MakeAppointmentServicesInfo.vehicleInfo[targetName]).change();
        } else if (response.length === 1) {
          jQuery(targetSelect).find('option:eq(1)').attr('selected', 'selected').trigger('change');
        }

      },
      error: function (response) {
        console.log(response);
      },
      complete: function (response) {
        //unlock the select boxes locked before the request
        unlocked.attr('disabled', false);
      }
    });
  },

  // assigns the required tag to all checkboxes if they are all empty.
  // removes required tag from all checkboxes if any of them are selected
  initCheckboxValidation: function () {
    const checkboxes = jQuery('.checkbox-validation');
    checkboxes.change(function () {
      if (jQuery('.checkbox-validation:checked').length > 0) {
        checkboxes.removeAttr('required');
      } else {
        checkboxes.attr('required', 'required');
      }
    });

    // Trigger the change event on any initially checked checkboxes
    jQuery('.checkbox-validation:checked').trigger('change');
  },

  /**
   * Oil Change confirmation modal.
   * Shown when the user submits the form without selecting an Oil Change service.
   * "Yes" selects the Oil Change service and submits the form.
   * "No" submits form without the Oil Change service.
   */
  oilChangeModal: {
    userDeclinedOilChange: false,

    show: function () {
      jQuery('#oil-change-modal-overlay').fadeIn(200);
    },

    hide: function () {
      jQuery('#oil-change-modal-overlay').fadeOut(200);
    },

    bindEvents: function () {
      jQuery('#oil-change-modal-yes').on('click', function () {
        // Select the oil change service checkbox
        jQuery('.make-appointment-services input[type=checkbox]').filter(function () {
          return this.id.indexOf('Oil_Change') !== -1 || jQuery(this).val() === 'Oil Change';
        }).prop('checked', true).trigger('change');

        MakeAppointmentServicesInfo.oilChangeModal.hide();

        // Re-trigger form submission (oil change is now selected so modal won't re-appear)
        jQuery('#make-appointment-services-info-form').submit();
      });

      jQuery('#oil-change-modal-no').on('click', function () {
        MakeAppointmentServicesInfo.oilChangeModal.userDeclinedOilChange = true;
        MakeAppointmentServicesInfo.oilChangeModal.hide();
        jQuery('#make-appointment-services-info-form').submit();
      });
    }
  }
};